import { categories } from '@/mocks/siteData';
import { Link } from 'react-router-dom';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold mb-4 whitespace-nowrap">
            Product Categories
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Explore Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-sm leading-relaxed">
            Browse through our organized product categories to find exactly what you are looking for. Each category links directly to curated spreadsheet resources on our main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-50 border border-background-200/40 group-hover:border-primary-200 group-hover:bg-primary-50 transition-colors">
                <i className="ri-shopping-bag-3-line text-xl text-foreground-600 group-hover:text-primary-600 transition-colors"></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/sugargoo-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-lg border border-background-200/60 hover:border-primary-300 hover:text-primary-700 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            View All Categories Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}